import React from 'react';
import classNames from 'classnames';
import {connect} from "react-redux";
import PropTypes from "prop-types";

import Analytics from './../../analytics';
import COLOR_THEMES from "../../colorThemes";

const CheckBox = (props) => {
  const {checked, text, onChecked, disabled, textOnly, activeTheme} = props;
  return (
    <div className={classNames('ui-svg-checkbox ui-svg-checkbox--tiny', {'ui-svg-checkbox--disabled': disabled})}
         onClick={() => !disabled && !textOnly && Analytics.sendClickEvent("checkbox - " + text, checked) && onChecked(!checked)}>
      <div className={classNames("ui-svg-checkbox__icon", {'ui-svg-checkbox__icon--disabled': disabled})}>
        {textOnly ? null :
          <svg className="ui-svg-checkbox__icon-circle" height="24" width="24">
            <circle cx="12" cy="12" r="10" stroke={COLOR_THEMES[activeTheme].primary} strokeWidth="2" fill="#ffffff"/>
          </svg>
        }
        {checked ?
          <div className="ui-svg-checkbox__icon-checked-icon"/>
          : <div className="ui-svg-checkbox__icon-circle"/> }
      </div>
      <div className="ui-svg-checkbox__text">{text}</div>
    </div>
  );
};

CheckBox.displayName = 'CheckBox';

CheckBox.propTypes = {
  checked: PropTypes.bool,
  disabled: PropTypes.bool,
  textOnly: PropTypes.bool,
  text: PropTypes.any,
  onChecked: PropTypes.func,
}

const mapStateToProps = (store) => {
  return {
    activeTheme: store.serverState.activeTheme,
  };
};

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(CheckBox)
